import { render, staticRenderFns } from "./DetailSection.vue?vue&type=template&id=2df0a712&scoped=true&"
import script from "./DetailSection.vue?vue&type=script&lang=js&"
export * from "./DetailSection.vue?vue&type=script&lang=js&"
import style0 from "./DetailSection.vue?vue&type=style&index=0&id=2df0a712&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df0a712",
  null
  
)

export default component.exports